import art2_imageSVG_1 from "../../../../src/content/article-2/google_Desktop2.svg";
import art2_imageSVG_2 from "../../../../src/content/article-2/google_Desktop3.svg";
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import * as React from 'react';
export default {
  art2_imageSVG_1,
  art2_imageSVG_2,
  getImage,
  GatsbyImage,
  React
};